(function () {
  'use strict';

  var raf1 = 0, raf2 = 0, wait1 = 0, wait2 = 0;

  function startDpi() {
    if (raf1) cancelAnimationFrame(raf1);
    clearTimeout(wait1);
    var hand = document.getElementById('dpHand');
    var handTrail = document.getElementById('dpTrail');
    var cur = ['dpC1', 'dpC2', 'dpC3'].map(function (id) { return document.getElementById(id); });
    var trail = ['dpT1', 'dpT2', 'dpT3'].map(function (id) { return document.getElementById(id); });
    if (!hand || !handTrail || cur.some(function (n) { return !n; }) || trail.some(function (n) { return !n; })) {
      wait1 = setTimeout(startDpi, 200);
      return;
    }
    var START = 2, SPAN = 96;
    var ratio = [0.125, 0.5, 1];
    var ease = function (x) { return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2; };
    var MOVE = 78, HOLD = 26, L = (MOVE + HOLD) * 2;
    var t = 0, last = 0;
    var tick = function (ts) {
      if (ts - last >= 16) {
        last = ts;
        var p = t % L, prog;
        if (p < MOVE) prog = ease(p / MOVE);
        else if (p < MOVE + HOLD) prog = 1;
        else if (p < MOVE * 2 + HOLD) prog = 1 - ease((p - MOVE - HOLD) / MOVE);
        else prog = 0;
        var handSpan = 23.2;
        hand.style.left = (38.4 + prog * handSpan) + '%';
        handTrail.style.width = (prog * handSpan) + '%';
        cur.forEach(function (n, i) {
          var d = prog * SPAN * ratio[i];
          n.style.left = (START + d) + '%';
          trail[i].style.width = d + '%';
        });
        t++;
      }
      raf1 = requestAnimationFrame(tick);
    };
    raf1 = requestAnimationFrame(tick);
  }

  function startJitter() {
    if (raf2) cancelAnimationFrame(raf2);
    clearTimeout(wait2);
    var lo = document.getElementById('jtLo'), hi = document.getElementById('jtHi');
    var loHit = document.getElementById('jtLoHit'), hiHit = document.getElementById('jtHiHit');
    var hand = document.getElementById('jtHand');
    if (!lo || !hi || !loHit || !hiHit || !hand) {
      wait2 = setTimeout(startJitter, 200);
      return;
    }
    var laneW = (hi.parentElement && hi.parentElement.offsetWidth) || 240;
    var AMP = Math.max(3.4, Math.min(5.5, (laneW / 2 - 16) / 8));
    var RADIUS = 17;
    var t = 0, last = 0;
    var noise = function (x, s) {
      return Math.sin(x * s) * 0.6 + Math.sin(x * s * 2.7 + 1.3) * 0.3 + Math.sin(x * s * 6.1 + 2.9) * 0.1;
    };
    var tick = function (ts) {
      if (ts - last >= 16) {
        last = ts;
        var nx = noise(t, 0.055), ny = noise(t + 40, 0.043);
        hand.style.transform = 'translate(' + (nx * AMP * 1.6) + 'px,' + (ny * AMP * 1.6 * 0.6) + 'px)';
        [[lo, 1, loHit], [hi, 8, hiHit]].forEach(function (row) {
          var node = row[0], mul = row[1], hitNode = row[2];
          var dx = nx * AMP * mul, dy = ny * AMP * mul * 0.35;
          node.style.transform = 'translate(' + dx + 'px,' + dy + 'px)';
          var inside = Math.hypot(dx, dy) <= RADIUS;
          hitNode.textContent = inside ? '的の中' : '外れ';
          hitNode.style.color = inside ? '#8fd3a4' : '#e88a9c';
        });
        t++;
      }
      raf2 = requestAnimationFrame(tick);
    };
    raf2 = requestAnimationFrame(tick);
  }

  function start() { startDpi(); startJitter(); }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
